// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"570":"493951a3","783":"f61e663d"}[chunkId] + ".chunk.js";
};